import { Step } from 'react-joyride';

export const tourSteps: Step[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Welcome to Zimsec Tutor!',
    content: 'Let\'s take a quick tour to help you get started with your learning journey.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="subject-picker"]',
    placement: 'bottom-start',
    title: 'Choose a Subject',
    content: 'Start by selecting the subject you want to study. Your chat and materials will update based on this selection.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="top-nav"]',
    placement: 'bottom',
    title: 'Main Navigation',
    content: 'Switch between chatting with your tutor, viewing your calendar for important dates, and checking your learning progress.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar"]',
    placement: 'right',
    title: 'Projects & History',
    content: 'Here you can access your projects and manage your learning materials. You can also switch between different chat threads.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="action-buttons"]',
    placement: 'bottom',
    title: 'Quick Actions',
    content: 'Quickly jump to your Projects, Homework, Revision materials, or send us Feedback using these buttons.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="chat-input"]',
    placement: 'top',
    title: 'Chat with your Tutor',
    content: 'Ask questions, upload files, or use voice notes to communicate with your AI tutor. It\'s here to help you understand complex topics.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="profile-menu"]',
    placement: 'left',
    title: 'Profile & Settings',
    content: 'Click here to open your profile menu. From here you can subscribe and unsubscribe from subjects, change your theme, view your progress, and restart this tour anytime.',
    skipBeacon: true,
  }
];
